module.exports = __webpack_public_path__ + "a4959d5b9044cf929c6256f9769fe117.jpg";